import { FC } from 'react'
import { Button } from 'shared/components/Button'
import { renderUntil } from 'shared/hocs/render'
import { colors } from 'shared/lib'
import styled from 'styled-components'

import { IRefinementListProps } from '../IRefinementListProps'

const ConditionsCardContent = styled.div`
  display: grid;
  grid-gap: 4px;
  grid-template-columns: 1fr;
  max-height: 200px;
  overflow-y: auto;
  padding: 20px;
`

const ConditionOptionButton = styled(Button)<{ isSelected: boolean }>`
  border-color: ${({ isSelected }) =>
    isSelected ? colors.FC2_BLACK : colors.FC2_LIGHTEST_GREY} !important;
`

const MobileListFilter: FC<IRefinementListProps> = ({ items, refine, qaAttr, selectedFilters }) => {
  return (
    <ConditionsCardContent>
      {items.map(({ label, value }) => (
        <ConditionOptionButton
          $fill
          buttonType="secondary"
          key={label}
          onClick={() => {
            refine(value)
          }}
          isSelected={selectedFilters.has(value)}
          qaAttr={qaAttr}
        >
          {label}
        </ConditionOptionButton>
      ))}
    </ConditionsCardContent>
  )
}

MobileListFilter.displayName = 'MobileListFilter'

export default renderUntil.large(MobileListFilter)
